module.exports = __webpack_public_path__ + "static/media/3a.78258ae4.jpg";